import { render } from "./PTApply.vue?vue&type=template&id=d08ae9ec&scoped=true"
import script from "./PTApply.vue?vue&type=script&lang=js"
export * from "./PTApply.vue?vue&type=script&lang=js"

import "./PTApply.vue?vue&type=style&index=0&id=d08ae9ec&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d08ae9ec"]])

export default __exports__